const Threshold = {
  phone: '700px',
  tablet: '1200px',
  desktop: '1440px',
  desktopLarge: '1920px'
}

export default Threshold
